import React from 'react';

export const OnlineSVGIcon = (props) => {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" {...props}>
      <path
        d="M17.6666 32.8333L6.83331 22L9.88831 18.9233L17.6666 26.7017L34.1116 10.2567L37.1666 13.3333M22 0.333344C19.1547 0.333344 16.3372 0.893768 13.7085 1.98262C11.0798 3.07147 8.69127 4.66743 6.67933 6.67936C2.61604 10.7427 0.333313 16.2537 0.333313 22C0.333313 27.7464 2.61604 33.2574 6.67933 37.3207C8.69127 39.3326 11.0798 40.9285 13.7085 42.0174C16.3372 43.1063 19.1547 43.6667 22 43.6667C27.7463 43.6667 33.2573 41.3839 37.3206 37.3207C41.3839 33.2574 43.6666 27.7464 43.6666 22C43.6666 19.1547 43.1062 16.3373 42.0174 13.7085C40.9285 11.0798 39.3326 8.6913 37.3206 6.67936C35.3087 4.66743 32.9202 3.07147 30.2915 1.98262C27.6627 0.893768 24.8453 0.333344 22 0.333344Z"
        fill="#42BA96"
      />
    </svg>
  );
};
